import React from 'react';
import PropTypes from 'prop-types';
import { useLabels, useRequestData } from 'wsm-common-data';
import { stepsConfig } from '../constants';
import StepCta from './StepCta';

const PopoverContent = ({ activeStep }) => {
	const { deviceType } = useRequestData();
	const labels = useLabels();

	return (
		<div
			data-testid="ws-track-my-offer-popover-content"
			style={{ width: deviceType === 'DESKTOP' ? '300px' : '275px' }}
		>
			{Object.keys(stepsConfig)
				.filter((step) => step !== activeStep)
				.map((key, index) => {
					return (
						<StepCta
							key={key}
							title={labels.get(
								stepsConfig[key].ctaLabel ||
									stepsConfig[key].titleLabel
							)}
							route={stepsConfig[key].route}
							classNames={
								Object.values(stepsConfig).length - 2 !== index
									? 'mb-3'
									: ''
							}
							stepKey={key}
						/>
					);
				})}
		</div>
	);
};

PopoverContent.propTypes = {
	activeStep: PropTypes.string.isRequired
};

export default PopoverContent;
